export default __webpack_public_path__ + "img/3a2622b8d7d166db905cbba7dfaf795c.svg";